import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Table, Modal, Button, Form, Tabs, Tab } from 'react-bootstrap';
import { FaCheck, FaSortAmountUp, FaSortAmountDown, FaArrowLeft, FaArrowRight, FaPercent, FaHandshake, FaInfoCircle, FaMoneyBillWave, FaUser, FaCreditCard, FaHistory, FaWallet, FaArrowUp, FaArrowDown } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const ListePartenaire = ({ titre }) => {
    useAuth();
    const [partenaires, setPartenaires] = useState([]);
    const [filteredPartenaires, setFilteredPartenaires] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [alert, setAlert] = useState({ message: '', type: '' });

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = partenaires.length;
    const [isLoading, setIsLoading] = useState(false);

    // Modal detail state
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [inscriptions, setInscriptions] = useState([]);
    const [loadingInscriptions, setLoadingInscriptions] = useState(false);
    const [currentInscriptionPage, setCurrentInscriptionPage] = useState(1);
    const [inscriptionsPerPage] = useState(5);
    const [inscriptionSearchTerm, setInscriptionSearchTerm] = useState('');
    const [historiqueTransactions, setHistoriqueTransactions] = useState([]);
    const [activeTab, setActiveTab] = useState('inscriptions');
    const [soldeData, setSoldeData] = useState({ total_entrees: 0, total_sorties: 0, solde: 0 });

    // Modal Paiement
    const [showPaiementModal, setShowPaiementModal] = useState(false);
    const [montantPaiement, setMontantPaiement] = useState('');
    const [modePaiement, setModePaiement] = useState('VIREMENT');
    const [referencePaiement, setReferencePaiement] = useState('');
    const [commentairePaiement, setCommentairePaiement] = useState('');
    const [isPaiementLoading, setIsPaiementLoading] = useState(false);

    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const [selectedPartenaire, setSelectedPartenaire] = useState(null);

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Liste des partenaires";
        }
    }, [user_id]);

    const fetchPartenaires = async () => {
        setIsLoading(true)
        try {
            const response = await axios.get(process.env.REACT_APP_HOTE + '/liste-partenaire/');
            setPartenaires(response.data);
            setFilteredPartenaires(response.data);
        } catch (error) {
            console.error('Error fetching partenaires:', error);
            showAlert('Erreur lors du chargement des partenaires', 'danger');
        } finally {
            setIsLoading(false)
        }
    };

    const fetchInscriptionsPartenaire = async (codePartenaire) => {
        setLoadingInscriptions(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/liste-inscriptions/?code_partenaire=${codePartenaire}&per_page=100`);
            setInscriptions(response.data.data || []);
        } catch (error) {
            console.error('Error fetching inscriptions:', error);
            showAlert('Erreur lors du chargement des inscriptions', 'danger');
        } finally {
            setLoadingInscriptions(false);
        }
    };

    const fetchHistoriqueTransactions = async (partenaireId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/liste-historique-partenaire/${partenaireId}/`);
            if (response.data.success) {
                setHistoriqueTransactions(response.data.transactions || []);
                setSoldeData(response.data.totaux || { total_entrees: 0, total_sorties: 0, solde: 0 });
            }
        } catch (error) {
            console.error('Error fetching historique:', error);
            setHistoriqueTransactions([]);
            setSoldeData({ total_entrees: 0, total_sorties: 0, solde: 0 });
        }
    };

    const enregistrerPaiement = async (partenaireId, montant, mode, reference, commentaire) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_HOTE}/enregistrer-paiement-partenaire/`, {
                partenaire_id: partenaireId,
                montant: montant,
                mode_transaction: mode,
                reference: reference,
                commentaire: commentaire,
                gestionnaire_id: user_id
            });
            return response.data;
        } catch (error) {
            console.error('Error enregistrant paiement:', error);
            throw error;
        }
    };

    useEffect(() => {
        fetchPartenaires();
    }, []);

    useEffect(() => {
        const results = partenaires.filter(partenaire =>
            partenaire.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
            partenaire.prenoms.toLowerCase().includes(searchTerm.toLowerCase()) ||
            partenaire.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (partenaire.pourcentage_partenariat && partenaire.pourcentage_partenariat.toLowerCase().includes(searchTerm.toLowerCase())) ||
            partenaire.tel.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredPartenaires(results);
    }, [searchTerm, partenaires]);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: '', type: '' }), 5000);
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const [sortConfigInscription, setSortConfigInscription] = useState({ key: 'id', direction: 'ascending' });
    const handleSortModalInscription = (key) => {
        let direction = 'ascending';
        if (sortConfigInscription?.key === key && sortConfigInscription?.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfigInscription({ key, direction });
    };

    const sortedPartenaires = [...filteredPartenaires].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'descending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'descending' ? 1 : -1;
        }
        return 0;
    });

    // Pagination logic for main table
    const indexOfLastPartenaire = currentPage * itemsPerPage;
    const indexOfFirstPartenaire = indexOfLastPartenaire - itemsPerPage;
    const currentPartenaires = sortedPartenaires.slice(indexOfFirstPartenaire, indexOfLastPartenaire);
    const totalPages = Math.ceil(sortedPartenaires.length / itemsPerPage);

    // Filter and pagination for inscriptions in modal
    const filteredInscriptions = inscriptions.filter(inscription =>
        inscription?.code_partenaire?.toLowerCase().includes(inscriptionSearchTerm.toLowerCase()) ||
        inscription?.nom?.toLowerCase().includes(inscriptionSearchTerm.toLowerCase()) ||
        inscription?.prenoms?.toLowerCase().includes(inscriptionSearchTerm.toLowerCase()) ||
        inscription?.email?.toLowerCase().includes(inscriptionSearchTerm.toLowerCase())
    );

    const sortedInscriptions = [...filteredInscriptions].sort((a, b) => {
        if (a[sortConfigInscription?.key] < b[sortConfigInscription?.key]) {
            return sortConfigInscription?.direction === 'descending' ? -1 : 1;
        }
        if (a[sortConfigInscription?.key] > b[sortConfigInscription?.key]) {
            return sortConfigInscription?.direction === 'descending' ? 1 : -1;
        }
        return 0;
    });

    const indexOfLastInscription = currentInscriptionPage * inscriptionsPerPage;
    const indexOfFirstInscription = indexOfLastInscription - inscriptionsPerPage;
    const currentInscriptions = sortedInscriptions?.slice(indexOfFirstInscription, indexOfLastInscription);
    const totalInscriptionPages = Math.ceil(sortedInscriptions?.length / inscriptionsPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handlePartenaireSelect = (partenaire) => {
        setSelectedPartenaire(prev => (prev && prev.id === partenaire.id ? null : partenaire));
    };

    const handleShowDetailModal = async (partenaire) => {
        setSelectedPartenaire(partenaire);
        if (partenaire.code_partenaire) {
            await Promise.all([
                fetchInscriptionsPartenaire(partenaire.code_partenaire),
                fetchHistoriqueTransactions(partenaire.id)
            ]);
        } else {
            setInscriptions([]);
            showAlert('Ce partenaire n\'a pas de code partenaire', 'warning');
        }
        setActiveTab('inscriptions');
        setShowDetailModal(true);
    };

    const handleCloseDetailModal = () => {
        setShowDetailModal(false);
        setInscriptionSearchTerm('');
        setCurrentInscriptionPage(1);
        setHistoriqueTransactions([]);
        setSelectedPartenaire(null)
    };

    const [showPourcentageModal, setShowPourcentageModal] = useState(false);
    const [pourcentage_partenariat, setPourcentage_partenariat] = useState(selectedPartenaire?.pourcentage_partenariat || 10);
    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const handleOpenPourcentageModal = () => {
        if (selectedPartenaire) {
            setPourcentage_partenariat(selectedPartenaire.pourcentage_partenariat || 10);
        }
        setShowPourcentageModal(true);
    };

    const handleClosePourcentageModal = () => {
        setShowPourcentageModal(false);
    };

    const handleDefinirPourcentage = async (e) => {
        e.preventDefault();
        setIsLoadingButton(true);

        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-profil-utilisateur/${selectedPartenaire.id}/${user_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    pourcentage_partenariat: pourcentage_partenariat
                })
            });

            if (!response.ok) throw new Error('Erreur réseau');
            const result = await response.json();

            showAlert(`Pourcentage défini sur ${pourcentage_partenariat}%`);
            fetchPartenaires()

        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur lors de la modification', 'danger');
        } finally {
            setIsLoadingButton(false);
            setShowPourcentageModal(false);
        }
    };

    // Gestion du paiement/transaction
    const handleOpenTransactionModal = () => {
        setMontantPaiement('');
        setModePaiement('VIREMENT');
        setReferencePaiement('');
        setCommentairePaiement('');
        setShowPaiementModal(true);
    };

    const handleClosePaiementModal = () => {
        setShowPaiementModal(false);
    };

    const handleEffectuerTransaction = async () => {
        if (!montantPaiement || parseFloat(montantPaiement) <= 0) {
            showAlert('Veuillez entrer un montant valide', 'danger');
            return;
        }

        setIsPaiementLoading(true);
        try {
            const result = await enregistrerPaiement(
                selectedPartenaire.id,
                parseFloat(montantPaiement),
                modePaiement,
                referencePaiement,
                commentairePaiement
            );
            
            if (result.success) {
                showAlert(result.message, 'success');
                handleClosePaiementModal();
                // Rafraîchir l'historique
                await fetchHistoriqueTransactions(selectedPartenaire.id);
                // Rafraîchir la liste des partenaires pour mettre à jour le gain_partenariat
                await fetchPartenaires();
            } else {
                showAlert(result.error || 'Erreur lors du paiement', 'danger');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur lors du paiement', 'danger');
        } finally {
            setIsPaiementLoading(false);
        }
    };

    // Vérification des accès
    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Partenaire")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2><FaHandshake size={25} className='mr-2' />Gestion des Partenaires</h2>
                            <small>Administration des partenaires.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        <Link to={`/Liste-partenaire`}> Partenaires</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {/* Modal pourcentage */}
                    <Modal show={showPourcentageModal} onHide={handleClosePourcentageModal}>
                        <Modal.Header>
                            <Modal.Title>Définir pourcentage</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Pourcentage partenariat</Form.Label>
                                    <Form.Control
                                        type="number"
                                        min="1"
                                        max="100"
                                        value={pourcentage_partenariat}
                                        onChange={(e) => setPourcentage_partenariat(Math.max(1, parseInt(e.target.value) || 1))}
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClosePourcentageModal}>
                                Fermer
                            </Button>
                            <Button
                                variant="success"
                                onClick={handleDefinirPourcentage}
                                disabled={isLoadingButton}
                            >
                                {isLoadingButton ? (
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ) : (
                                    'Définir'
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal pour les détails des inscriptions */}
                    <Modal show={showDetailModal} onHide={handleCloseDetailModal} size="xl">
                        <Modal.Header>
                            <Modal.Title>
                                Détails du partenaire - {selectedPartenaire?.nom} {selectedPartenaire?.prenoms}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {/* Résumé des gains */}
                            <div className="alert alert-success mb-3">
                                <strong>Total des gains générés :</strong> {selectedPartenaire?.gain_partenariat ? parseFloat(selectedPartenaire.gain_partenariat).toLocaleString() : 0} FCFA
                            </div>

                            {/* Onglets */}
                            <Tabs
                                activeKey={activeTab}
                                onSelect={(k) => setActiveTab(k)}
                                className="mb-3"
                            >
                                <Tab eventKey="inscriptions" title={
                                    <span><FaMoneyBillWave className="mr-1" /> Inscriptions</span>
                                }>
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            placeholder="Rechercher une inscription (nom, prénom, email)..."
                                            className="form-control"
                                            value={inscriptionSearchTerm}
                                            onChange={(e) => {
                                                setInscriptionSearchTerm(e.target.value);
                                                setCurrentInscriptionPage(1);
                                            }}
                                        />
                                    </div>

                                    {loadingInscriptions ? (
                                        <div className="text-center">
                                            <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                <thead>
                                                    <tr>
                                                        <th onClick={() => handleSortModalInscription('date_inscription')}>Date inscription</th>
                                                        <th onClick={() => handleSortModalInscription('nom')}>Nom</th>
                                                        <th onClick={() => handleSortModalInscription('prenoms')}>Prénoms</th>
                                                        <th onClick={() => handleSortModalInscription('email')}>Email</th>
                                                        <th className="text-center" onClick={() => handleSortModalInscription('montant_facture')}>Montant formation</th>
                                                        <th className="text-center" onClick={() => handleSortModalInscription('gain')}>Gain partenaire</th>
                                                        <th className="text-center" onClick={() => handleSortModalInscription('solde')}>Statut</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentInscriptions.length > 0 ? (
                                                        currentInscriptions.map((inscription, index) => {
                                                            const montantFacture = inscription.montant_facture ? parseFloat(inscription.montant_facture) : 0;
                                                            const gain = montantFacture * ((inscription.discount || 0) / 100);
                                                            const estSolde = inscription.solde_complet === true;
                                                            
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{new Date(inscription.date_inscription).toLocaleDateString()}</td>
                                                                    <td>{inscription.nom}</td>
                                                                    <td>{inscription.prenoms}</td>
                                                                    <td>{inscription.email}</td>
                                                                    <td className="text-center">{montantFacture.toLocaleString()} FCFA</td>
                                                                    <td className="text-center">{Math.round(gain).toLocaleString()} FCFA</td>
                                                                    <td className="text-center">
                                                                        {estSolde ? (
                                                                            <span className="badge bg-success">Soldé</span>
                                                                        ) : (
                                                                            <span className="badge bg-warning">Non soldé</span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-center">
                                                                Aucune inscription trouvée
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            {filteredInscriptions.length > 0 && (
                                                <span>
                                                    Éléments {indexOfFirstInscription + 1} à {Math.min(indexOfLastInscription, filteredInscriptions.length)} sur {filteredInscriptions.length}
                                                </span>
                                            )}
                                        </div>
                                        <div>
                                            <button
                                                onClick={() => setCurrentInscriptionPage(prev => Math.max(prev - 1, 1))}
                                                disabled={currentInscriptionPage === 1}
                                                className="btn btn-light mx-1"
                                            >
                                                <FaArrowLeft />
                                            </button>

                                            {(() => {
                                                const pagesToShow = 5;
                                                let startPage = Math.max(1, currentInscriptionPage - Math.floor(pagesToShow / 2));
                                                let endPage = Math.min(totalInscriptionPages, startPage + pagesToShow - 1);

                                                if (endPage - startPage < pagesToShow - 1) {
                                                    startPage = Math.max(1, endPage - pagesToShow + 1);
                                                }

                                                const pageButtons = [];

                                                for (let i = startPage; i <= endPage; i++) {
                                                    pageButtons.push(
                                                        <button
                                                            key={i}
                                                            onClick={() => setCurrentInscriptionPage(i)}
                                                            className={`btn ${currentInscriptionPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                        >
                                                            {i}
                                                        </button>
                                                    );
                                                }

                                                return pageButtons;
                                            })()}
                                            <button
                                                onClick={() => setCurrentInscriptionPage(prev => Math.min(prev + 1, totalInscriptionPages))}
                                                disabled={currentInscriptionPage === totalInscriptionPages}
                                                className="btn btn-light mx-1"
                                            >
                                                <FaArrowRight />
                                            </button>
                                        </div>
                                    </div>
                                </Tab>
                                
                                <Tab eventKey="historique" title={
                                    <span><FaHistory className="mr-1" /> Historique</span>
                                }>
                                    {/* <div className="mb-3 d-flex justify-content-end">
                                        <Button 
                                            variant="warning" 
                                            size="sm" 
                                            onClick={handleOpenTransactionModal}
                                            className="d-flex align-items-center"
                                        >
                                            <FaWallet className="mr-2" />
                                            Nouveau paiement
                                        </Button>
                                    </div> */}

                                    <div className="table-responsive">
                                        <table className="table table-striped table-hover">
                                            <thead className="bg-light">
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Type</th>
                                                    <th>Montant</th>
                                                    <th>Mode</th>
                                                    <th>Référence</th>
                                                    <th>Commentaire</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {historiqueTransactions.length > 0 ? (
                                                    historiqueTransactions.map((transaction) => (
                                                        <tr key={transaction.id}>
                                                            <td>{new Date(transaction.date).toLocaleDateString()}</td>
                                                            <td>
                                                                {transaction.type === 'ENTREE' ? (
                                                                    <span className="badge bg-success">
                                                                        <FaArrowUp className="mr-1" /> Entrée
                                                                    </span>
                                                                ) : (
                                                                    <span className="badge bg-danger">
                                                                        <FaArrowDown className="mr-1" /> Sortie
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td className={`fw-bold ${transaction.type === 'ENTREE' ? 'text-success' : 'text-danger'}`}>
                                                                {transaction.type === 'ENTREE' ? '+' : '-'} {transaction.montant.toLocaleString()} FCFA
                                                            </td>
                                                            <td>{
                                                                transaction.mode === 'VIREMENT' ? 'Virement bancaire' :
                                                                transaction.mode === 'ORANGE_MONEY' ? 'Orange Money' :
                                                                transaction.mode === 'MTN_MONEY' ? 'MTN Mobile Money' :
                                                                transaction.mode === 'MOOV_MONEY' ? 'Moov Money' :
                                                                transaction.mode === 'ESPECES' ? 'Espèces' :
                                                                transaction.mode === 'CHEQUE' ? 'Chèque' : transaction.mode
                                                            }</td>
                                                            <td><code>{transaction.reference}</code></td>
                                                            <td>{transaction.commentaire}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center text-muted">
                                                            Aucun historique de transaction
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            {/* <tfoot className="bg-light">
                                                <tr>
                                                    <td colSpan="2" className="text-end fw-bold">Total entrées :</td>
                                                    <td className="text-success fw-bold">{soldeData.total_entrees.toLocaleString()} FCFA</td>
                                                    <td colSpan="3"></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2" className="text-end fw-bold">Total sorties :</td>
                                                    <td className="text-danger fw-bold">{soldeData.total_sorties.toLocaleString()} FCFA</td>
                                                    <td colSpan="3"></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2" className="text-end fw-bold">Solde :</td>
                                                    <td className="fw-bold text-primary">{soldeData.solde.toLocaleString()} FCFA</td>
                                                    <td colSpan="3"></td>
                                                </tr>
                                            </tfoot> */}
                                        </table>
                                    </div>
                                </Tab>
                            </Tabs>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDetailModal}>
                                Fermer
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal Paiement */}
                    <Modal show={showPaiementModal} onHide={handleClosePaiementModal} size="md">
                        <Modal.Header>
                            <Modal.Title className="d-flex align-items-center">
                                <FaWallet className="mr-2" />
                                Effectuer un paiement
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Montant à payer <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="0"
                                        value={montantPaiement}
                                        onChange={(e) => setMontantPaiement(e.target.value)}
                                        min="0"
                                        step="1000"
                                    />
                                    <Form.Text className="text-muted">
                                        Montant en Francs CFA (FCFA)
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Mode de paiement</Form.Label>
                                    <Form.Select
                                        value={modePaiement}
                                        onChange={(e) => setModePaiement(e.target.value)}
                                        className='custom-select'
                                    >
                                        <option value="VIREMENT">Virement bancaire</option>
                                        <option value="ORANGE_MONEY">Orange Money</option>
                                        <option value="MTN_MONEY">MTN Mobile Money</option>
                                        <option value="MOOV_MONEY">Moov Money</option>
                                        <option value="ESPECES">Espèces</option>
                                        <option value="CHEQUE">Chèque</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Commentaire (optionnel)</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        placeholder="Ajouter un commentaire..."
                                        value={commentairePaiement}
                                        onChange={(e) => setCommentairePaiement(e.target.value)}
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClosePaiementModal}>
                                Annuler
                            </Button>
                            <Button 
                                variant="success" 
                                onClick={handleEffectuerTransaction}
                                disabled={isPaiementLoading || !montantPaiement || parseFloat(montantPaiement) <= 0}
                            >
                                {isPaiementLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                        Traitement...
                                    </>
                                ) : (
                                    <>
                                        <FaCheck className="mr-2" />
                                        Effectuer le paiement
                                    </>
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <div className="mt-3">
                        {alert.message && (
                            <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2`}>
                                <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                                <span
                                    onClick={fermerNotif}
                                    style={{
                                        position: 'absolute',
                                        top: '0px',
                                        right: '10px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <i className='fa fa-close'></i>
                                </span>
                            </div>
                        )}
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des partenaires</h5>
                                <div className="d-flex">
                                    <button
                                        onClick={handleOpenPourcentageModal}
                                        disabled={!selectedPartenaire}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 mr-2 ${selectedPartenaire ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaPercent />
                                        <span className="d-none d-sm-inline ml-2">
                                            pourcentage
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleOpenTransactionModal}
                                        disabled={!selectedPartenaire}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 mr-2 ${selectedPartenaire ? 'btn-warning' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaWallet />
                                        <span className="d-none d-sm-inline ml-2">
                                            Payer
                                        </span>
                                    </button>
                                    <button
                                        disabled={!selectedPartenaire}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 ${selectedPartenaire ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                        onClick={(e) => {
                                            handleShowDetailModal(selectedPartenaire);
                                        }}
                                    >
                                        <FaInfoCircle />
                                        <span className="d-none d-sm-inline ml-2">
                                            Détails
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <select
                                                    value={itemsPerPage}
                                                    onChange={handleItemsPerPageChange}
                                                    className="form-select bg-light p-1"
                                                    style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                </select>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control w-25"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nom')}>Nom {sortConfig.key === 'nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('prenoms')}>Prénoms {sortConfig.key === 'prenoms'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('email')}>Email {sortConfig.key === 'email'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('tel')}>Téléphone {sortConfig.key === 'tel'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('pourcentage_partenariat')}>Commission {sortConfig.key === 'pourcentage_partenariat'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-center d-none d-md-table-cell'>Total gains</th>
                                                        </tr>
                                                    </thead>

                                                    {!isLoading ? (
                                                        <tbody>
                                                            {currentPartenaires.map((partenaire) => {
                                                                return (
                                                                    <tr
                                                                        key={partenaire.id}
                                                                        onClick={() => handlePartenaireSelect(partenaire)}
                                                                        className={`bg-white ${selectedPartenaire && selectedPartenaire.id === partenaire.id ? 'bg-success text-white' : ''}`}
                                                                    >
                                                                        <td>
                                                                            {partenaire.nom}
                                                                            <div className='lesInfos'>
                                                                                <small>Prénoms : {partenaire.prenoms}</small><br />
                                                                                <small>Email : {partenaire.email}</small><br />
                                                                                <small>Téléphone : {partenaire.tel}</small>
                                                                                <small>Commission : {partenaire.pourcentage_partenariat || 0}%</small>
                                                                            </div>
                                                                        </td>
                                                                        <td className="d-none d-md-table-cell text-justify">{partenaire.prenoms}</td>
                                                                        <td className="d-none d-md-table-cell text-center">{partenaire.email}</td>
                                                                        <td className="d-none d-md-table-cell text-center">{partenaire.tel}</td>
                                                                        <td className="d-none d-md-table-cell text-center">{partenaire.pourcentage_partenariat ? partenaire.pourcentage_partenariat : '0'}%</td>
                                                                        <td className="d-none d-md-table-cell text-center">{partenaire.gain_partenariat ? parseFloat(partenaire.gain_partenariat).toLocaleString() : 0} FCFA</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <td>
                                                                <td colSpan="6" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </td>
                                                        </tbody>
                                                    )}
                                                </table>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstPartenaire + 1} à ${Math.min(indexOfLastPartenaire, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListePartenaire;